import React, { useLayoutEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const ScrollStackSection = ({ cards = [] }) => {
  const containerRef = useRef(null);
  const sectionsRef = useRef([]);
  sectionsRef.current = [];

  const addToRefs = (el) => {
    if (el && !sectionsRef.current.includes(el)) {
      sectionsRef.current.push(el);
    }
  };

  useLayoutEffect(() => {
    const container = containerRef.current;
    const sections = sectionsRef.current;

    if (!container || sections.length === 0) return;

    const ctx = gsap.context(() => {
      gsap.set(sections, {
        zIndex: (i) => i,
      });

      gsap.set(sections.slice(1), {
        yPercent: 100,
      });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container,
          pin: true,
          scrub: 1,
          end: () => "+=" + (sections.length - 1) * 100 + "%",
          // markers: true,
        },
      });

      sections.slice(1).forEach((section, i) => {
        tl.to(
          section,
          {
            yPercent: 0,
            ease: "none",
          },
          `+=${i * 0.01}`
        ); // Add a tiny delay
      });
    }, container);

    return () => ctx.revert();
  }, [cards]);

  if (!cards || cards.length === 0) {
    return null;
  }

  return (
    <div ref={containerRef} className="relative h-screen overflow-hidden">
      {cards.map((card, index) => (
        <section
          key={card.id || index}
          ref={addToRefs}
          className="absolute inset-0 h-full w-full text-white flex items-center p-6 md:p-20"
          style={{
            backgroundColor: card.backgroundColor || "#2d3339",
          }}
        >
          <div className="flex flex-col md:flex-row justify-between items-center w-full text-left gap-8">
            <div className="w-full">
              <h2 className="text-3xl md:text-5xl font-bold">{card.title}</h2>
              <p className="mt-4 md:mt-8 max-w-none md:max-w-md">
                {card.description}
              </p>
            </div>
            {card.image && (
              <img
                src={card.image}
                alt={card.imageAlt || `Image ${index + 1}`}
                className="w-full md:w-1/3 h-auto object-cover"
              />
            )}
          </div>
        </section>
      ))}
    </div>
  );
};

export default ScrollStackSection;
